import { IRootState } from '../../../../store'
import { IMotorVehicleIncidentState } from '../store/motorVehicleIncident.types'

export const getMotorVehicleIncidentSelector = (state: IRootState): IMotorVehicleIncidentState =>
  state.motorVehicleIncident
